import { useState } from 'react';

import {
    Button,
    Grid,
    Alert,
    Typography,
} from "@mui/material";


import { Formik } from "formik";

import { useNavigate } from 'react-router-dom';

const display_text = 'You can now login with your new password.';

const ResetSuccess = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    return (
        <>
          <Formik
            initialValues={{
                submit: null,
            }}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                setStatus({ success: false });
                setSubmitting(false);
                setLoading(true);
    
                navigate("/login");
    
            }}
          >
            {({
                errors,
                handleSubmit,
                isSubmitting,
            }) => (
              <form noValidate onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    {errors.submit && (
                    <Grid item xs={12}>
                        <Alert
                            severity="error"
                            sx={{ background: "#FFB4AB", color: "#a3080a" }}
                        >
                        {errors.submit}
                        </Alert>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Typography variant='h6' sx={{ textAlign: 'center', marginTop: "-20px"}}>
                        {display_text}
                    </Typography>
                  </Grid>
            

                  <Grid item xs={12}>
                       <Button
                        disableElevation
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={loading}
                      >
                        Back to login
                      </Button>
                    
                  </Grid>

                </Grid>
              </form>
            )}
          </Formik>
        </>
      );
}


export default ResetSuccess;